import styled from "styled-components";
import { useTranslation } from "react-i18next";
import MainNavbar from "../components/Navbar/MainNavbar";
import Typography from "../components/Typography";
import UserSettingsContent from "../components/UserSettings/UserSettingsContent";

function UserSettingsPage() {
	const { t } = useTranslation("userProfile");

	return (
		<PageWrapper>
			<MainNavbar />
			<PageHeader>
				<Container>
					<Typography
						as="h1"
						$variant="title-4-semibold"
						$variantTablet="title-5-semibold"
						$variantMobile="body-1-semibold"
					>
						{t("settings.title")}
					</Typography>
				</Container>
			</PageHeader>
			<ContentArea>
				<UserSettingsContent />
			</ContentArea>
		</PageWrapper>
	);
}

export default UserSettingsPage;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ContentArea = styled(PageHeader)``;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.md};
  padding-bottom: 0px;
  max-width: 1400px;
  width: 100%;
  gap: ${({ theme }) => theme.sizing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.sm};
    padding-bottom: 0px;
  }
`;
